import { IconProps } from '../../atoms/icons/icon'
import { TravelTypeEnum } from '../../../lib/graphql'

export const formatHouseAddress = ({
  department,
  region,
}: {
  department?: string
  region?: string
}) => {
  return [department, region].filter(Boolean).join(', ')
}

export const getClientProposalFallbackSvg = (
  travelType: TravelTypeEnum,
): IconProps['name'] => {
  switch (travelType) {
    case TravelTypeEnum.BUSINESS_MEAL:
      return 'restaurant'

    case TravelTypeEnum.CORPORATE_EVENING_EVENT:
      return 'celebration'

    case TravelTypeEnum.DAILY_TRIP:
      return 'sun'

    case TravelTypeEnum.NIGHTLY_TRIP:
      return 'moon'

    case TravelTypeEnum.TEAM_BUILDING:
      return 'happy-team'

    case TravelTypeEnum.TRANSPORT:
      return 'train'

    default:
      return 'question-mark'
  }
}
